import { render } from "./Invitations.vue?vue&type=template&id=264691d2&scoped=true&ts=true"
import script from "./Invitations.vue?vue&type=script&lang=ts"
export * from "./Invitations.vue?vue&type=script&lang=ts"

import "./Invitations.vue?vue&type=style&index=0&id=264691d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264691d2"]])

export default __exports__